export default __webpack_public_path__ + "static/media/IMG-20240822-WA0008.6c3affe2.jpg";